export enum ErrorScreenType {
  EVENT_NOT_FOUND = 'EVENT_NOT_FOUND',
  ALBUM_NOT_FOUND = 'ALBUM_NOT_FOUND',
  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
  SERVER_ERROR = 'SERVER_ERROR',
  CHUNK_ERROR = 'CHUNK_ERROR',
}

export interface ErrorScreenConfig {
  icon: string;
  titleKey: string;
  messageKey: string;
  actionKey: string;
  actionRoute?: string;
  isReload?: boolean;
}
